import { userGroups } from 'js/components/group-permissions';

export const lawyerInformationNamedPermissions = {
  editLawyerInformation: [userGroups.administrator, userGroups.dataEntry],
};

export const lawyerPanelsNamedPermissions = {
  editLawyerPanels: [userGroups.administrator, userGroups.dataEntry],
};
